import { useTranslate } from "@similarweb/i18n-provider";

import manageIntegrationsTrackingService from "app/pages/sales-intelligence/modules/manage-integrations/services/tracking";
import managementTrackingService from "app/pages/sales-intelligence/modules/management/services/tracking/managementTrackingService";
import { MANAGEMENT_COMMON_CONNECT } from "app/pages/sales-intelligence/pages/management/translations/managementKeys";
import siNavigator from "app/pages/sales-intelligence/services/siNavigator";

import IntegrationButtonWrapperWithFeatureRequest from "app/pages/sales-intelligence/modules/manage-integrations/components/integration-button/IntegrationButtonWrapperWithFeatureRequest";
import { StyledManagementCardButton } from "../../components/cards-components/styles";
import useSignalsApiData from "../../hooks/useSignalsApiData";

const SignalsGatewayButtonContainer = (): React.ReactElement => {
    const { translate } = useTranslate();

    const { isEnabled, hasAccess } = useSignalsApiData();

    const handleConnectClick = () => {
        manageIntegrationsTrackingService.trackGatewayConnect("signalsWebhook");
        void siNavigator.goToManagementSignalsApiPage();
    };

    const handleUpgradeClick = () => {
        managementTrackingService.trackSignalApiHook("signals API/upgrade");
    };

    return (
        <IntegrationButtonWrapperWithFeatureRequest
            hookId="SignalsApi"
            dataAutomationNameSpace="signals-webhook"
            featureName="signalsWebhook"
            upgradeButtonText={translate("si.common.contact_us")}
            hasAccess={hasAccess}
            isEnabled={isEnabled}
            onUpgradeClick={handleUpgradeClick}
        >
            <StyledManagementCardButton
                buttonHtmlType="button"
                type="primary"
                onClick={handleConnectClick}
                data-automation="signals-webhook.gateway-connect-button"
            >
                {translate(MANAGEMENT_COMMON_CONNECT)}
            </StyledManagementCardButton>
        </IntegrationButtonWrapperWithFeatureRequest>
    );
};

export default SignalsGatewayButtonContainer;
